// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared header for interior pages: dark olive band, extra-bold Poppins
   title in page cream (6.28), pale-green tagline (5.68). */
.page-hero {
  background-color: var(--surface-hero);
  color: var(--text-on-hero-muted);
  padding: 64px 0;
}

.page-hero h1 {
  font-family: var(--font-display);
  font-weight: 800;
  font-size: clamp(2.4rem, 7vw, 4rem) !important;
  line-height: 1.1;
  color: var(--text-on-hero);
  margin-bottom: 16px;
}

.page-hero p {
  max-width: 640px;
  font-size: 1.15rem;
  margin: 0;
}

.story-body {
  max-width: 760px;
}

.story-body p {
  margin-bottom: 12px;
  font-size: 1.05rem;
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 24px;
}

.value-card {
  background-color: var(--surface-raised);
  border-radius: var(--radius-md);
  padding: 24px;
  box-shadow: var(--shadow-soft);
}
`, "",{"version":3,"sources":["webpack://./src/pages/AboutUs.css"],"names":[],"mappings":"AAAA;2DAC2D;AAC3D;EACE,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,8CAA8C;EAC9C,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;AAChC","sourcesContent":["/* Shared header for interior pages: dark olive band, extra-bold Poppins\n   title in page cream (6.28), pale-green tagline (5.68). */\n.page-hero {\n  background-color: var(--surface-hero);\n  color: var(--text-on-hero-muted);\n  padding: 64px 0;\n}\n\n.page-hero h1 {\n  font-family: var(--font-display);\n  font-weight: 800;\n  font-size: clamp(2.4rem, 7vw, 4rem) !important;\n  line-height: 1.1;\n  color: var(--text-on-hero);\n  margin-bottom: 16px;\n}\n\n.page-hero p {\n  max-width: 640px;\n  font-size: 1.15rem;\n  margin: 0;\n}\n\n.story-body {\n  max-width: 760px;\n}\n\n.story-body p {\n  margin-bottom: 12px;\n  font-size: 1.05rem;\n}\n\n.values-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 24px;\n}\n\n.value-card {\n  background-color: var(--surface-raised);\n  border-radius: var(--radius-md);\n  padding: 24px;\n  box-shadow: var(--shadow-soft);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
